<template>
  <div>
    <v-container fluid>
      <v-card class="card">
        <v-toolbar color="primary" dark>
          <v-toolbar-title class="title">{{$t('menumanagement')}}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-title class="title">{{today}}</v-toolbar-title>
        </v-toolbar>
        <v-flex class="flex">
          <v-row style="margin-top:2rem;">
            <v-col cols="3" class="mt-3">
              <v-autocomplete
                v-model="value"
                :items="menusDDL"
                dense
                :label="$t('menuname')"
                item-text="MenuName"
                item-value="MenuName"
                clearable
              ></v-autocomplete>
            </v-col>

            <v-col cols="3">
              <v-btn class="primary white--text mt-3" @click="Search">{{$t('search')}}</v-btn>
            </v-col>
          </v-row>
          <v-data-table :items="menus">
            <template v-slot:header="{ props: { headers } }">
              <thead>
                <tr>
                  <th scope="col">{{$t('menuname')}}</th>
                  <th scope="col">{{$t('addgroupinmenu')}}</th>
                </tr>
              </thead>
            </template>
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.MenuName}}</td>
                <td>
                  <v-btn icon @click="Edit(item)" :disabled="checkPermissionTwo(11,12)">
                    <img :src="images.edit" alt="Edit menu" />
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <br />
        <br />
        <br />
      </v-card>
    </v-container>

    <!-- Add User Group In Menu -->
    <!-- Search which user groups have which menus by check menu item -->
    <v-dialog v-model="EditdialogUser" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{$t('menumanagement')}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <div v-if="tempID==0" v-show="true">
              <v-col cols="12" sm="6" md="2">
                <v-checkbox
                  v-model="checkbox1"
                  color="#1976D2"
                  :label="$t('all')"
                  value="0"
                  @click="SearchMenuInDDL"
                ></v-checkbox>
              </v-col>
            </div>

            <div v-if="tempID==0" v-show="true">
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-autocomplete
                    :items="menus[tempID].Submenus"
                    :label="$t('menuNameStar')"
                    item-value="id"
                    item-text="SubmenuName"
                    :disabled="check()"
                    clearable
                    v-model="subMenuID"
                    @blur="SearchMenuInDDL"
                    multiple
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-autocomplete
                    v-model="groupList"
                    :items="GroupList"
                    :label="$t('userGroupStar')"
                    item-text="groupName"
                    item-value="id"
                    clearable
                    multiple
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </div>
            <div v-else-if="tempID==1" v-show="true">
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-autocomplete
                    v-model="MenuID1"
                    :items="menus[tempID]"
                    :label="$t('menuNameStar')"
                    item-value="id"
                    item-text="MenuName"
                    clearable
                    multiple
                    @blur="SearchMenuInDDL"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-autocomplete
                    v-model="groupList2"
                    :items="GroupList"
                    :label="$t('userGroupStar')"
                    item-text="groupName"
                    item-value="id"
                    clearable
                    multiple
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </div>
            <div v-else-if="tempID==2" v-show="true">
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-autocomplete
                    v-model="MenuID2"
                    :items="menus[tempID]"
                    :label="$t('menuNameStar')"
                    item-value="id"
                    item-text="MenuName"
                    clearable
                    @blur="SearchMenuInDDL"
                    multiple
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-autocomplete
                    v-model="groupList3"
                    :items="GroupList"
                    :label="$t('userGroupStar')"
                    item-text="groupName"
                    item-value="id"
                    clearable
                    multiple
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </div>
            <div v-else v-show="true">
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-autocomplete
                    v-model="MenuID3"
                    :items="menus[tempID]"
                    :label="$t('menuNameStar')"
                    item-value="id"
                    item-text="MenuName"
                    clearable
                    @blur="SearchMenuInDDL"
                    multiple
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-autocomplete
                    v-model="groupList4"
                    :items="GroupList"
                    :label="$t('userGroupStar')"
                    item-text="groupName"
                    item-value="id"
                    clearable
                    multiple
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </div>
          </v-container>
          <small>*{{ $t('indicatesrequiredfield') }}</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="Refresh">{{ $t('close') }}</v-btn>
          <div v-if="tempID==0" v-show="true">
            <v-btn color="blue darken-1" text @click="AddGroupInMenu">{{ $t('add') }}</v-btn>
          </div>
          <div v-else-if="tempID==1" v-show="true">
            <v-btn color="blue darken-1" text @click="AddGroupInMenuManagement">{{ $t('add') }}</v-btn>
          </div>
          <div v-else-if="tempID==2" v-show="true">
            <v-btn color="blue darken-1" text @click="AddGroupInCalendar">{{ $t('add') }}</v-btn>
          </div>
          <div v-else v-show="true">
            <v-btn color="blue darken-1" text @click="AddGroupInLog">{{ $t('add') }}</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import checkPermissionTwo from "@/api/function.js";
const LogTrace = checkPermissionTwo;
export default {
  name: "MenuManagement",
  mixins: [checkPermissionTwo,LogTrace],
  data: () => ({
    checkbox1: false,
    EditdialogUser: false,
    tempID: 0,
    MenuID1: null,
    MenuID2: null,
    MenuID3: null,
    menuID: null,
    subMenuID: null,
    today: null,
    value: null,
    groupList: null,
    groupList2: null,
    groupList3: null,
    groupList4: null,
    GroupList: [],
    menusDDL: [
      { MenuName: "User Management" },
      { MenuName: "Menu Management" },
      {
        MenuName: "Calendar"
      }
    ],
    menus: [
      {
        id: 0,
        MenuName: "User Management",
        Submenus: [
          { id: 11, SubmenuName: "Users" },
          { id: 22, SubmenuName: "User Group" },
          { id: 33, SubmenuName: "Permission Management" }
        ]
      },
      {
        id: 1,
        MenuName: "Menu Management"
      },
      {
        id: 2,
        MenuName: "Calendar"
      },
      {
        id: 3,
        MenuName: "Log"
      }
    ],
    images: {
      edit: require("@/assets/edit1.png")
    }
  }),

  methods: {
    Refresh() {
      this.EditdialogUser = false;
      globalThis.location.reload();
    },
    Search() {
      this.dialog = true;
      if (this.value == null) {
        globalThis.location.reload();
        alert(this.$t('pleaseEnterMenuName'));
        this.dialog = false;
      } else {
        let List = this.menusDDL;
        this.menus = [];
        for (const item of List) {
          if (item.MenuName == this.value) {
            this.menus.push(item);
          }
        }
        this.dialog = false;
      }
    },
    SearchMenuInDDL() {
      let tempMenuID = "";
      let tempsubmenu = this.subMenuID + "";
      if (this.menuID == 0) {
        tempMenuID = this.checkbox1 ? this.checkbox1 : tempsubmenu;
        this.dialog = true;
      } else if (this.MenuID1 == 1) {
        tempMenuID = this.MenuID1.toString();
        this.dialog = true;
      } else if (this.MenuID2 == 2) {
        tempMenuID = this.MenuID2.toString();
        this.dialog = true;
      } else if (this.MenuID3 == 3) {
        tempMenuID = this.MenuID3.toString();
        this.dialog = true;
      }
      let tempRole = {
        menu_id: tempMenuID
      };
      this.dialog = true;
      axios
        .post(`${this.url}Menu/GetMenuByID`, tempRole)
        .then((response) => {
          if (response.data.status == 0) {
            this.groupList = response.data.data;
            this.groupList2 = response.data.data;
            this.groupList3 = response.data.data;
            this.groupList4= response.data.data;

            this.groupList = this.groupList.map(x => Number.parseInt(x.id));
            this.groupList2 = this.groupList2.map(x => Number.parseInt(x.id));
            this.groupList3 = this.groupList3.map(x => Number.parseInt(x.id));
            this.groupList4 = this.groupList4.map(x => Number.parseInt(x.id));
            if (
              this.groupList.length == [] ||
              this.groupList2.length == [] ||
              this.groupList3.length == [] ||
              this.groupList4.length == []
            ) {
              alert(this.$t('menuHadNoChosenGroup'));
              this.dialog = false;
            }

            this.dialog = false;
          }
        })
        .catch((error) => {
          alert(error);
          this.dialog = false;
        });
    },
    AddGroupInMenu() {
      try{
      this.dialog = true;
      let tempsubmenu = this.subMenuID + "";
      let templist = this.groupList + "";
      if (tempsubmenu != "null" || templist != "null") {
        let tempRole = {
          menu_id: this.checkbox1 ? this.checkbox1 : tempsubmenu,
          group_id: templist == "" ? null : templist
        };
        axios
          .post(`${this.url}Menu/UpdateMenuManagement`, tempRole)
          .then((response) => {
            if (response.data.status == 0) {
              alert(response.data.message);
              this.Editdialog = false;
              this.groupList2 = null;
              this.dialog = false;
              this.EditdialogUser = false;
              globalThis.location.reload();
            }
          })
          .catch((error) => {
            alert(error);
            this.dialog = false;
            this.EditdialogUser = false;
          });
      } else {
        alert(this.$t('pleaseSelectAllFields'));
        this.dialog = false;
      }
      }catch(error){
        this.LogTrace(error,"AddGroupInMenu")
      }
    },

    AddGroupInMenuManagement() {
      try{
      this.dialog = true;
      let tempmenu = this.MenuID1 + "";
      let templist = this.groupList2 + "";
      if (tempmenu != "null" || templist != "null") {
        let tempRole = {
          menu_id: tempmenu,
          group_id: templist == "" ? null : templist
        };

        axios
          .post(`${this.url}Menu/UpdateMenuManagement`, tempRole)
          .then((response) => {
            if (response.data.status == 0) {
              alert(response.data.message);
              this.Editdialog = false;
              this.groupList2 = null;
              this.dialog = false;
              this.EditdialogUser = false;
              globalThis.location.reload();
            }
          })
          .catch((error) => {
            alert(error);
            this.dialog = false;
            this.EditdialogMenu = false;
          });
      } else {
        alert(this.$t('pleaseFillAllFields'));
        this.dialog = false;
      }
      }catch(error){
        this.LogTrace(error,"AddGroupInMenuManagement")
      }
    },
    AddGroupInCalendar() {
    try{
      this.dialog = true;
      let tempmenu = this.MenuID2 + "";
      let templist = this.groupList3 + "";
      if (tempmenu != "null" || templist != "null") {
        let tempRole = {
          menu_id: tempmenu,
          group_id: templist == "" ? null : templist
        };

        axios
          .post(`${this.url}Menu/UpdateMenuManagement`, tempRole)
          .then((response) => {
            if (response.data.status == 0) {
              alert(response.data.message);
              this.EditdialogCalendar = false;
              this.groupList3 = null;
              this.dialog = false;
              globalThis.location.reload();
            }
          })
          .catch((error) => {
            alert(error);
            this.dialog = false;
            this.EditdialogUser = false;
          });
      } else {
        alert(this.$t('pleaseFillAllFields'));
        this.dialog = false;
      }
    }catch(error){
      this.LogTrace(error,"AddGroupInMenuManagement")
    }
    },
    AddGroupInLog() {
      try{
      this.dialog = true;
      let tempmenu = this.MenuID3 + "";
      let templist = this.groupList4 + "";
      if (tempmenu != "null" || templist != "null") {
        let tempRole = {
          menu_id: tempmenu,
          group_id: templist == "" ? null : templist
        };

        axios
          .post(`${this.url}Menu/UpdateMenuManagement`, tempRole)
          .then((response) => {
            if (response.data.status == 0) {
              alert(response.data.message);
              this.EditdialogCalendar = false;
              this.groupList4 = null;
              this.dialog = false;
              globalThis.location.reload();
            }
          })
          .catch((error) => {
            alert(error);
            this.dialog = false;
            this.EditdialogUser = false;
          });
      } else {
        alert(this.$t('pleaseFillAllFields'));
        this.dialog = false;
      }
      }catch(error){
        this.LogTrace(error,"AddGroupInLog")
      }
    },
    GetGroupManagement() {
      this.dialog = true;
      axios
        .post(`${this.url}Group/GetGroupAll`)
        .then((response) => {
          this.GroupList = response.data.data;
          this.dialog = false;
        })
        .catch((error) => {
          alert(error);
        });
    },
    check() {
      if (this.checkbox1 == false || this.checkbox1 == null) { //NOSONAR
        return false;
      } else if (this.checkbox1 == "0") {
        return true;
      }
    },
    Edit(item) {
      this.tempID = item.id;
      this.menuID = item.id;
      this.EditdialogUser = true;
    },
  },
  mounted() {
    this.GetDate();
    this.GetGroupManagement();
  }
};
</script>
<style scoped>
.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
</style>